<template>
    <vue-scroll>
        <div class="page-header">
            <h1>Themes</h1>
        </div>
        <el-tabs v-model="activeTab">
            <el-tab-pane name="monthly-pdf-themes" label="Monthly PDF Themes">
                <monthly-pdf-themes />
            </el-tab-pane>
            <el-tab-pane
                name="digital-display-backgrounds"
                label="Digital Display Backgrounds"
            >
                <digital-display-backgrounds />
            </el-tab-pane>
        </el-tabs>
    </vue-scroll>
</template>

<script>
import MonthlyPdfThemes from "./themes/MonthlyPdfThemes";
import DigitalDisplayBackgrounds from "./themes/DigitalDisplayBackgrounds";

export default {
    data() {
        return {
            activeTab: "monthly-pdf-themes",
        };
    },
    components: {
        MonthlyPdfThemes,
        DigitalDisplayBackgrounds,
    },
    methods: {},
};
</script>

<style scoped></style>
